import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQPage.scss'


interface FAQ {
    question: string;
    answer: string;
  }
  
  const FAQPage: React.FC = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
  

    const faqs = [
    {
      question: "What is Kitchen9?",
      answer: "Kitchen9 is an AI-powered platform that generates personalized recipes, allows users to share and customize recipes, and helps with meal planning and grocery list creation."
    },
    {
      question: "How does the AI recipe generator work?",
      answer: "Our AI recipe generator uses advanced machine learning algorithms to create unique recipes based on your preferences, dietary restrictions, available ingredients, and cooking skill level. Simply input your requirements, and the AI will generate a tailored recipe for you."
    },
    {
      question: "Is Kitchen9 free to use?",
      answer: "Kitchen9 offers both free and premium features. Basic recipe browsing and sharing are free, while advanced AI-generated recipes and meal planning tools are part of our premium subscription. Check our pricing page for more details."
    },
    {
      question: "Can I share my own recipes on Kitchen9?",
      answer: "Yes! We encourage users to share their own recipes. You can upload recipes, add photos, and even create video tutorials to share with the Kitchen9 community."
    },
    {
      question: "How accurate are the nutritional information and calorie counts?",
      answer: "We strive for accuracy in our nutritional information and calorie counts, which are calculated based on standard ingredient databases. However, please note that these are estimates and may vary based on specific brands or preparation methods. Always consult with a nutritionist or healthcare professional for personalized dietary advice."
    },
    {
      question: "Can I adjust serving sizes for recipes?",
      answer: "Yes, most recipes on Kitchen9 allow you to adjust serving sizes. The ingredient quantities will automatically update to match your desired number of servings."
    },
    {
      question: "How do I report inappropriate content or copyright infringement?",
      answer: "If you come across any inappropriate content or believe there's a copyright infringement, please use the 'Report' button next to the content or contact our support team at support@kitchen9.com. We take these matters seriously and will investigate promptly."
    },
    {
      question: "Is my personal information safe on Kitchen9?",
      answer: "We take data privacy very seriously. Your personal information is encrypted and stored securely. We do not sell your data to third parties. For more details, please review our Privacy Policy."
    },
    {
      question: "Can I use Kitchen9 if I have dietary restrictions or allergies?",
      answer: "Absolutely! When using our AI recipe generator or browsing recipes, you can specify dietary restrictions, allergies, or ingredients to avoid. Our system will take these into account when suggesting or generating recipes for you."
    },
    {
      question: "How do I cancel my premium subscription?",
      answer: "You can cancel your premium subscription at any time from your account settings. If you cancel, you'll continue to have access to premium features until the end of your current billing cycle. After that, your account will revert to the free tier."
    },
    {
      question: "Can I integrate Kitchen9 with my smart kitchen appliances?",
      answer: "We're currently working on integrations with popular smart kitchen appliance brands. Stay tuned for updates on this feature!"
    },
    {
      question: "How can I suggest new features or improvements?",
      answer: "We love hearing from our users! You can suggest new features or improvements through our feedback form in the app or by emailing ideas@kitchen9.com. We regularly review user suggestions for future updates."
    },
    {
      question: "Is there a mobile app for Kitchen9?",
      answer: "Yes, Kitchen9 is available as a mobile app for both iOS and Android devices. You can download it from the App Store or Google Play Store."
    },
    {
      question: "How do I reset my password?",
      answer: "To reset your password, click on the 'Forgot Password' link on the login page. Enter your email address, and we'll send you instructions to reset your password. For security reasons, password reset links expire after 24 hours."
    },
    {
      question: "Can I use Kitchen9 offline?",
      answer: "While most features require an internet connection, premium users can download recipes for offline use. The AI recipe generation feature requires an active internet connection."
    }
  ];

  const toggleFAQ = (index: number): void => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <h1>Frequently Asked Questions</h1>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <h3
              className={activeIndex === index ? 'active' : ''}
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
            </h3>
            <p className={activeIndex === index ? 'active' : ''}>
              {faq.answer}
            </p>
          </div>
        ))}
      </div>
      <div className="additional-info">
        <p>Can't find what you're looking for? Check out our <Link to="/help-center">Help Center</Link> or <Link to="/contact">contact our support team</Link>.</p>
      </div>
    </div>
  );
};

export default FAQPage;